
import { GET_ALL_MEETING_CATEGORIES, GET_RECORDED_MEETING_ADMIN_ALL_CATEGORY, CATEGORY_GENERATE_CODE } from './api/PtaQuery';
import { useLazyQuery, useMutation } from '@apollo/client';
import { useCallback, useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { visibility } from '../../redux/slices/rightSideAd';
import { formatSavedDate, formatVideosCount, getScreenDimensions } from '../../utils/helper';
import { setCurrentSessionDetail } from '../../redux/slices/dashboardSlice';
import { debounce, Tooltip } from '@mui/material';
import { Category } from '@mui/icons-material';
import { useGlobalState } from '../../MeetContext/MeetContext';
import { useNavigate } from 'react-router-dom';
import MaterialActionsOverlay, { MenuItemType } from '../../components/ActionsOverlay/MaterialActionsOverlay';
import PtaMeetingPopup from '../../components/PtaMeetingPopup/PtaMeetingPopup';
import CreateSchedulePta from '../../components/CreateSchedulePta/CreateSchedulePta';
import PtaHeader from '../../components/PtaHeader/PtaHeader';
import PreviousMeetings from '../../components/PreviousMeetings/PreviousMeetings';
import VideoViewer from '../../components/VideoViewer/VideoViewer';
import Loader from '../../components/Loader/Loader';
import ToasterWithMessage from '../../components/toaster';
import images from '../../assets/images';
import './AdminPta.scss';
import { CLASSROOM_S3_PATH, FETCH_POLICY } from '../../utils/constants';
import MobileScreenHeader from '../../components/MobileScreenHeader/MobileScreenHeader';
import { useAppSelector } from '../../redux/app/hooks';
import { setHideScrollToTopButton } from '../../redux/slices/authSlice';

export interface RecorderPtaMeetingType {
  rsId: string,
  topic: string,
  recordSessionType: string,
  cId: string,
  sessionId: string,
  savedSessionUrl: string,
  videosPlaybacktimesByRsId: {
    nodes: [{
      playbackTime: string;
    }]
  },
  playbackTime: any,
  createdAt: string
}

export interface MeetingCategoryType {
  mcId: string,
  mcType: string,
  mcOriginalType: string,
  mcTypeCapitalized: string,
  mcDescription: string,
  mcOrder: number,
  mcUrl: string,
  mcCode: string,
  deletedAt: string | null,
  createdAt: string
}

const AdminPta = () => {

  const { error } = ToasterWithMessage();
  const { localStream, setIsMeetingEndByHost } = useGlobalState();
  const { PTA_meeting_icon, backArrow, MoreIcon, searchCloseIcon, searchIcon } = images;
  const [showCreateScheduling,setShowCreateScheduling] = useState<boolean>(false);
  const [savedSessionsList, setSavedSessionsList] = useState<RecorderPtaMeetingType[]>();
  const [clickedVideoUrl,setClickedVideoUrl] = useState<string>();
  const [clickedCategoryDetails,setClickedCategoryDetails] = useState<MeetingCategoryType>();
  const [searchValue, setSearchValue] = useState<string>("");
  const [category, setCategory] = useState<MeetingCategoryType[]>([]);
  const [clickedVideoData, setClickedVideoData] = useState<RecorderPtaMeetingType>();
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const [openOverlay, setOpenOverlay] = useState<boolean>(false);
  const [openPtaPopup, setOpenPtaPopup] = useState<boolean>(false);
  const [genratedCode, setGeneratedCode] = useState<string | undefined>();
  const [ptaPopupType, setPtaPopupType] = useState<'generateCode' | 'copyCode' | 'editCategory' | 'shareCode'>();
  const [refetch, setRefetch] = useState<boolean>(false);
  const [isTitleOverflow,setIsTitleOverflow] = useState<boolean[]>([]);
  const titleRefs = useRef<Array<HTMLSpanElement | null>>([]);
  const videoRef = useRef<HTMLVideoElement | null>(null);
  const baseURL = process.env.REACT_APP_FRONTEND_URL;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { isMobileScreen } = getScreenDimensions();
  const [isSearchClick, setisSearchClick] = useState<boolean>(false);
  const { adminProfileImage, adminProfile, role } = useAppSelector((state) => state?.auth);
  const StudentName = adminProfile?.getCurrentUser?.nodes?.[0]?.uFullName;
  const menuItem: MenuItemType[] = [
    {
        label: "Rename",
        onClick: () => {
        setPtaPopupType("editCategory");
        setOpenPtaPopup(true);
        handleCloseActions();
        }
    },
    {
        label: "Generate code",
        onClick: () => {
        setPtaPopupType("generateCode");
        setOpenPtaPopup(true);
        handleCloseActions();
        }
    }
  ] 

  const [getAllMeetingCategory, { loading: categoryLoading }] = useLazyQuery(GET_ALL_MEETING_CATEGORIES, {
    fetchPolicy: FETCH_POLICY,
    onCompleted: (data) => {
      setCategory(data?.allMeetingCategories?.nodes);
      // fetchRecordedSessions();
    },
    onError: (err) => {
      error(err?.message);
    }
  })

  const [ getRecordedMeetingAdminAllCategory, { loading: loadingPtaRecordedAdmin } ] = useLazyQuery(GET_RECORDED_MEETING_ADMIN_ALL_CATEGORY, {
    fetchPolicy: FETCH_POLICY,
    onCompleted: (data) => {
      setSavedSessionsList(data?.allRecordedSessions?.nodes);
    },
    onError: (err) => {
      error(err?.message);
    }
  });

  const [ categoryGenerateCode ] = useMutation(CATEGORY_GENERATE_CODE, {
    fetchPolicy: FETCH_POLICY,
    onCompleted: (data) => {
      setGeneratedCode(data?.editMeetingCategoryCode);
      setPtaPopupType("copyCode");
    },
    onError: (err) => {
      error(err?.message);
    }
  });

  // Check if the title is overflowing
  const checkOverflow = (index: number) => {
    if (titleRefs.current[index]) {
      const overflow = titleRefs?.current[index]!.scrollHeight > titleRefs?.current[index]!.clientHeight;
      setIsTitleOverflow(prev => {
          const newOverflow = [...prev];
          newOverflow[index] = overflow;
          return newOverflow;
      });
    }
  };


  // Use useEffect to run checkOverflow after render
  useEffect(() => {
    dispatch(visibility({ isVisible: false }));
    if(category){
      category?.forEach((_, index) => {
        checkOverflow(index);
    });
    }

    const handleResize = () => {
      category?.forEach((_, index) => {
          checkOverflow(index);
      });
    };

    window.addEventListener('resize', handleResize);
    
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [Category]);

  useEffect(() => {
      getAllMeetingCategory();
      getRecordedMeetingAdminAllCategory({
        variables: {
          limit: null,
          offset: null,
          searchInput: `%${searchValue}%`
        }
      });
  },[ refetch ])

  useEffect(() => {
    dispatch(setCurrentSessionDetail({startDate: null, endDate: null}));
    setIsMeetingEndByHost(false);
      //To set stop camera and microphone when initial render.
      if(localStream?.getVideoTracks()[0]){
            localStream.getVideoTracks()[0].enabled = false;
        }
        localStream?.getVideoTracks()[0]?.stop();
        if(localStream?.getAudioTracks()[0]){
            localStream.getAudioTracks()[0].enabled = false;
        }
        localStream?.getAudioTracks()[0]?.stop();
  }, [])

  const handleBack = () => {
    setShowCreateScheduling(false);
  }  

  //To close video detailed view
  const handleCloseVideo = () => {
    setClickedVideoData(undefined);
    setClickedVideoUrl(undefined);
  }

  const handleClickCategory = (val: MeetingCategoryType) => {
    handleCloseVideo();
    navigate("/admin-pta/meetings", {
      state: { category: val}
    })
  }  

  const handleClickMoreIcon = (event: React.MouseEvent<HTMLElement>, category: MeetingCategoryType, type: 'category') => {
    event.stopPropagation();
    if (category) {
        setAnchorEl(event.currentTarget);
        setOpenOverlay(true);
        setClickedCategoryDetails(category);
    }
  };

  const handleCloseActions = () => {
      setAnchorEl(null);
      setOpenOverlay(false);
  };

  const closePtaPopup = () => {
    setOpenPtaPopup(false);
    setGeneratedCode(undefined);
  }

  const handleGeneratecode = () => {
    categoryGenerateCode({
      variables: {
        input: {
          mcId: clickedCategoryDetails?.mcId
        }
      }
    })
  }
  
  const handleSearchDebounceAdmin = useCallback(
    debounce((value, searchCategory) => {
        setSearchValue(value);
        getRecordedMeetingAdminAllCategory({
          variables: {
            limit: null,
            offset: null,
            searchInput: `%${value}%`
          }
        });
    }, 500),
    [getRecordedMeetingAdminAllCategory]
  );

  const showLoader = loadingPtaRecordedAdmin || categoryLoading;

  const headingRefs = useRef<(HTMLDivElement | null)[]>([]);
  const [isHeadingOverflow, setIsHeadingOverflow] = useState<boolean[]>([]);

  const checkHeadingOverflow = (index: number) => {
    const element = headingRefs.current[index];
    if (element) {
      const isOverflowing = element.scrollWidth > element.clientWidth;
      setIsHeadingOverflow((prev) => {
        const newOverflow = [...prev];
        newOverflow[index] = isOverflowing;
        return newOverflow;
      });
    }
  };

  const handleSearchClick = () => {
    setisSearchClick(true);
  }

  const handleCloseSearch = () => {
      setisSearchClick(false);
      setSearchValue("");
      handleSearchDebounceAdmin("", undefined);
  }

  const searchOnChange = (event: { target: { value: any; }; }) => {
    setSearchValue(event.target.value);
    if (handleSearchDebounceAdmin) {
      handleSearchDebounceAdmin(event?.target?.value, undefined);
    }
  }

  useEffect(() => {
      dispatch(setHideScrollToTopButton({hideScrollToTopButton: !showCreateScheduling }));
  }, [showCreateScheduling])

  useEffect(() => {
    dispatch(setHideScrollToTopButton({hideScrollToTopButton: !clickedVideoUrl }));
  }, [clickedVideoUrl])

  return (
    <>
      {(!clickedVideoUrl) ? (
        <div className={`AdminPtaMainContainer ${(category && category.length === 0) && 'noData'}`}>
          {isSearchClick && !showCreateScheduling && <div className={`ptaSearch ${(isMobileScreen && isSearchClick) ? 'mobileSearch' : ''}`}>
              <div className='SearchIconContainer'><img src={searchIcon} alt='searchIcon' className='commonSearchIconStyle' /></div>
              <input id="searchBox" type='text' placeholder='Search' onChange={searchOnChange} value={searchValue} className='SearchInputFieldStyle' />
              {(isMobileScreen && isSearchClick) && <img src={searchCloseIcon} alt='closeIcon' className='closeIcon' onClick={handleCloseSearch} />}
          </div>}
          {isMobileScreen && !isSearchClick && !showCreateScheduling && (
            <MobileScreenHeader
                handleSearchClick={handleSearchClick}
                profileImage={adminProfileImage}
                role={role}
                studentName={StudentName}
                profile={adminProfile}
            />
          )}
          {!isSearchClick && <PtaHeader
            title={(showCreateScheduling && isMobileScreen) ? "Schedule your PTA Meetings" : "All PTA Meeting"}
            addLabel=''
            subtitle={showCreateScheduling ? "" : formatVideosCount(savedSessionsList?.length || 0)}
            subImage={showCreateScheduling ? backArrow : PTA_meeting_icon}
            searchValue={searchValue}
            setSearchValue={setSearchValue}
            handleSearchDebounce={handleSearchDebounceAdmin}
            setShowCreateScheduling={setShowCreateScheduling}
            {...((!showCreateScheduling) && { setShowCreateScheduling })}
            handleBack={handleBack}
            selectedCategory={undefined}
            isShowBackArrow={true}
            showCreateScheduling={showCreateScheduling}
          />}

          {showLoader && <Loader bottom='100px'/>}

          {(showCreateScheduling && !showLoader && !isSearchClick) && (
            <div className='createScheduleMainContainer'>
              <CreateSchedulePta setShowCreateScheduling={setShowCreateScheduling} />
            </div>
          )}
          
          {(!showCreateScheduling && !showLoader && !isSearchClick) && (
            <div className={`categoryCardContainer ${category.length === 0 && 'noData'}`}>
              {(category && category.length > 0) ? category?.map((val: MeetingCategoryType, index: number) => (
                <div className='categoryCard' key={val?.mcId} onClick={() => handleClickCategory(val)}>
                  <div className='categoryInnerContainer'>
                      <div className='moreIconContainer'>
                        <img className='icons' src={baseURL + CLASSROOM_S3_PATH + val?.mcUrl} alt='icons'/>
                        <div className='moreIconInnerContainer' onClick={(e) => handleClickMoreIcon(e, val, 'category')}>
                          <img className='moreIcon' src={MoreIcon} alt='moreIcon'/>
                        </div>
                      </div>
                  <Tooltip
                    title={val?.mcOriginalType}
                    disableHoverListener={!isHeadingOverflow[index]}
                    placement='top'
                  >
                    <div
                      className="title"
                      ref={(el) => (headingRefs.current[index] = el)} 
                      onMouseEnter={() => checkHeadingOverflow(index)}
                    >
                      {val?.mcOriginalType}
                    </div>
                  </Tooltip>

                      <Tooltip title={val.mcDescription} disableHoverListener={!isTitleOverflow[index]} onMouseEnter={() => checkOverflow(index)} placement="top">
                        <span 
                         className='description'
                         ref={(el) => (titleRefs.current[index] = el)}
                         >
                          { val?.mcDescription }
                        </span>
                      </Tooltip>
                  </div>
              </div>
              )) : (
                <div className='noDataFoundStyle'>No data found</div>
                )} 
            </div>
          )}

          {(!showLoader && !showCreateScheduling) && (
            <div className={`previousMeetingContainer ${(!savedSessionsList || savedSessionsList?.length === 0) && isMobileScreen ? "noDataContainer" : ""}`}>
              <PreviousMeetings 
                setClickedVideoUrl = {setClickedVideoUrl} 
                savedSessionsList = {savedSessionsList} 
                setClickedVideoData = {setClickedVideoData}
                isSearchClick = {isSearchClick } 
              />
            </div>
          )}

        </div>
      ) : (
        <div className='viewVideoContainer'>
          <div className='viewVideoHeader'>
            <div className='headerLeft'>
              <img src={backArrow} onClick={handleCloseVideo} alt='backArrow' className='backIcon' />
              <div>{ clickedVideoData?.topic }</div>
            </div>
            <div className='headerRight'><span>{ formatSavedDate(clickedVideoData?.createdAt) }</span></div>
          </div>
          <div className='videoViewer'>
            <VideoViewer 
              video={clickedVideoUrl ? clickedVideoUrl : ''} 
              onClose={handleCloseVideo} 
              type={"Pta Meeting"} 
              videoRef = {videoRef}
              videoId = {clickedVideoData?.rsId ? clickedVideoData?.rsId : ''}
              videoData = {clickedVideoData}
            />
          </div>
        </div>
      )}

      <MaterialActionsOverlay
        anchorEl={anchorEl}
        open={openOverlay}
        handleClose={handleCloseActions}
        menuItems={menuItem}
        actionsHeight={'90px'}
        position={'left'}
        verticalPosition="bottom"
      />

      {(ptaPopupType) && (
        <PtaMeetingPopup 
          message='This meeting code is generated once then you can copy and share with your PTA members'
          openPopup={openPtaPopup}
          closePopup={closePtaPopup}
          type={ptaPopupType}
          handleClick={handleGeneratecode}
          value={genratedCode}
          setRefetch={setRefetch}
          clickedCategoryDetails={clickedCategoryDetails}
          refetch={refetch}
        />
      )}
    </>
  )
}

export default AdminPta;
